import React from 'react';

const Header = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="text-center md:text-left flex flex-col md:flex-row justify-between items-center mb-3 md:mb-5">
      {children}
    </div>
  );
};

export default Header;
